export function convertCCtoLitre(value: number): number {
    return value / 1000;
}
